import React from 'react';

const WidgetEtc = (props) => {
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  return (
    <>
      <div className="widget-container">
        <div className="">
          <div className="widget-title">
            선택 목록에 원하시는 문의가 없으신가요?
          </div>
        </div>
        <div>
          <ul className="widget-content">
            <li>
              [처음으로] 가셔서 해당하는 주제를 선택해 주세요. 결제, 환불,
              멤버십, 로그인, 재생 등 선택하시면 문제 해결 안내를 받아 보실 수
              있습니다.
            </li>
            <li>FAQ를 통해서 자주 묻는 질문들을 확인 할 수 있습니다.</li>
            <li>
              위에서도 해결하기 어려운 내용이나 문제상황이 있의면 Q&A에 문의를
              남겨주세요. 확인 후 답변드리겠습니다.
            </li>
            <li>
              <a>고객 센터로 이동하기</a>
            </li>
            <li onClick={_goHome}>
              <a>처음으로</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="widget-time">{props.payload.writetime}</div>
    </>
  );
};

export default WidgetEtc;
